import { useIsMobile } from '@brg/ui';
import { FC, useCallback } from 'react';
import { LinkSvg, LinkSvgSmall, TwitterSvg, TelegramSvg } from '../../../components/social-item';
import { DesignerSocialNetworkIcon } from '../styles';

export interface DesignerSocialNetworkProps {
    type: string;
    link: string;
}

export const DesignerSocialNetwork: FC<DesignerSocialNetworkProps> = ({type, link }) => {
    const onLinkClick = useCallback(() => {
        window.open(link, '_blank')
    }, [link]);
    const isMobile = useIsMobile();

    return (
        <DesignerSocialNetworkIcon key={type} onClick={onLinkClick}>
            {type === 'twitter' && <TwitterSvg />}
            {type === 'web-site' && (isMobile ? <LinkSvgSmall /> : <LinkSvg />)}
            {type === 'telegram' && <TelegramSvg />}
        </DesignerSocialNetworkIcon>
    );
};
import { useIsMobile } from '@brg/ui';
import { FC, useCallback } from 'react';
import { LinkSvg, LinkSvgSmall, TwitterSvg, TelegramSvg } from '../../../components/social-item';
import { DesignerSocialNetworkIcon } from '../styles';

export interface DesignerSocialNetworkProps {
    type: string;
    link: string;
}

export const DesignerSocialNetwork: FC<DesignerSocialNetworkProps> = ({type, link }) => {
    const onLinkClick = useCallback(() => {
        window.open(link, '_blank')
    }, [link]);
    const isMobile = useIsMobile();

    return (
        <DesignerSocialNetworkIcon key={type} onClick={onLinkClick}>
            {type === 'twitter' && <TwitterSvg />}
            {type === 'web-site' && (isMobile ? <LinkSvgSmall /> : <LinkSvg />)}
            {type === 'telegram' && <TelegramSvg />}
        </DesignerSocialNetworkIcon>
    );
};
